export const APP_CONFIG = {
    storageKey: 'MY_APP_STORAGE_KEY_2024'  // You can change this key
  };